/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable import/no-unresolved, import/default */

import valueInputTemplate from './value-input.tpl.html';

/* eslint-enable import/no-unresolved, import/default */


export default angular.module('agrolog.components.valueInput', [])
    .directive('agValueInput', ValueInput)
    .name;

// NOTE: copied and modified from temperature-input.directive.js
/*@ngInject*/
function ValueInput($compile, $templateCache) {

    var linker = function (scope, element, attrs, ngModelCtrl) {
        var template = $templateCache.get(valueInputTemplate);
        element.html(template);
        
        scope.unit = '';

        scope.$watch('type', (type) => {
            if (type == 'temperature') {
                scope.unit = '°C'
            } else if (type == 'humidity') {
                scope.unit = 'Rh %'
            } else if (type == 'moisture') {
                scope.unit = '%'
            }
        })

        scope.$watch('agMin', (newValue) => {
            if (angular.isDefined(newValue)) {
                scope.agDisplayMin = newValue + 0.01;
            }
        });

        scope.$watch('agMax', (newValue) => {
            if (angular.isDefined(newValue)) {
                scope.agDisplayMax = newValue - 0.01;
            }
        });

        scope.fieldName = 'ag-input-' + Math.random()*1000;

        scope.agError = angular.isDefined(scope.agRequired) || angular.isDefined(scope.agMin) || angular.isDefined(scope.agMax);

        scope.updateView = function () {
            if (!scope.disabled) {
                ngModelCtrl.$setViewValue(scope.value);
            }
        };

        ngModelCtrl.$render = function () {
            if (ngModelCtrl.$viewValue) {
              scope.value = ngModelCtrl.$viewValue
            } else {
              scope.value = null;
            }
        };

        scope.$watch('value', function () {
            scope.updateView();
        });

        scope.$watch('disabled', function () {
            scope.updateView();
        });

        $compile(element.contents())(scope);

    }

    return {
        restrict: "E",
        require: "^ngModel",
        link: linker,
        scope: {
            label: '@',
            type: '=?',
            requiredText: '@',
            minText: '@',
            maxText: '@',
            agRequired: '=?',
            agMin: '=?',
            agMax: '=?',
            disabled:'=ngDisabled',
            theForm: '=?'
        }
    };
}
